import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { EditPageGeneral as View } from './EditPageGeneral'

export const EditPageGeneral = withStyles(styles)(View)
